module.exports = __webpack_public_path__ + "img/maitri-patel.b21e0ba3.png";